const moment = require('moment-timezone');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate dateTimeFormatterBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const dateTimeValue = await evaluateSource(source.dateTimeValue, content, parentContentPath, transientContext, nativeFunctions);
  if (dateTimeValue === undefined) {
    return undefined;
  }
  const dateTimeFormat = await evaluateSource(source.dateTimeFormat, content, parentContentPath, transientContext, nativeFunctions);
  if (dateTimeFormat === undefined) {
    return undefined;
  }
  const timeZone = await evaluateSource(source.timeZone, content, parentContentPath, transientContext, nativeFunctions);
  try {
    const dateTime = moment.utc(new Date(dateTimeValue));
    const zonedDateTime = timeZone === undefined ? dateTime.local() : dateTime.tz(timeZone);
    return zonedDateTime.format(dateTimeFormat);
  } catch (_unused) {
    return undefined;
  }
};
module.exports = {
  evaluate
};